import Field from "./form/Field";

export default function GroupsList({groups, selectedOption, ...props}) {
  const transformGroupData = (groupData) => {
    let list = groupData.map((group) => ({
      key: group.group_id,
      value: group.group_id,
      name: group.group_name
    }))

    if (groupData.length > 1) {
      list.unshift({
        key: "",
        value: "",
        name: "Selecione um bolão"
      });
    }

    return list;
  }

  return(
    <>
    {groups.length > 0 && (
      <form className="mx-4">
        <div className={`flex flex-row justify-center ${ (selectedOption && selectedOption !== '') ? 'lg:justify-start' : ''}`}>
          <div className="pt-5 pr-4">Bolão:</div>
          <Field
            klass={"w-2/3 items-start"}
            type={"select"}
            name={"tournament_id"}
            id={"tournament_id"}
            label={""}
            required={""}
            onChange={props.groupOnClick}
            options={transformGroupData(groups)}
            defaultValue={selectedOption}/>
          </div>
      </form>
    )}
    </>
  )
}
